import React from 'react';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function RecommendationsSection({ teacher }) {
  return (
    <div className="p-6 pb-16 mb-6 sm:w-[90%] w-full mx-auto">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center">
          SPECIAL RECOMMENDATIONS
        </h2>
        <div className="bg-gradient-primary w-[100px] h-1 rounded-full mx-auto mt-4">
          <div className="bg-light w-1 h-1 translate-x-[20px]"></div>
        </div>
      </div>

      <Swiper
        className="custom-slider"
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          769: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          },
        }}
        navigation
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
      >
        {teacher.recommendations && teacher.recommendations.length > 0 ? (
          teacher.recommendations.map((recommendation, index) => (
            <SwiperSlide key={index}>
              <div className="bg-gray-800 rounded-lg p-6 h-full mx-2">
                <div className="flex flex-wrap sm:flex-nowrap items-center gap-4 sm:mb-4 mb-8">
                  <img
                    src={recommendation.avatar ?? '/assets/images/profile_placeholder.jpg'}
                    alt={recommendation.recommender_name}
                    className="sm:w-16 sm:h-16 w-20 h-20 sm:mx-0 mx-auto rounded-full object-cover border-2 border-orange-500"
                  />
                  <div className="flex-1 min-w-full sm:min-w-0 sm:text-left text-center">
                    <h4 className="text-white font-semibold capitalize text-lg truncate">
                      {recommendation.recommender_name}
                    </h4>
                    <p className="text-gray-400 text-sm truncate">
                      {recommendation.recommender_relation}
                    </p>
                  </div>
                </div>
                <p className="text-gray-400 text-sm italic sm:text-left text-center">
                  "{recommendation.body}"
                </p>
              </div>
            </SwiperSlide>
          ))
        ) : (
          <div className="text-center py-10 bg-gradient-glass rounded-lg">
            <p className="text-gray-400 text-lg">No recommendations yet.</p>
          </div>
        )}
      </Swiper>
    </div>
  );
}

export default RecommendationsSection;
